import React from 'react';
import { StyledDiv } from 'up-ops-web-shared-components/lib';

import { SectionHeader } from 'styles/CommonStyles';

type FormHeaderProps = {
  description: string | JSX.Element;
  title: string;
};

const FormHeader = ({ description, title }: FormHeaderProps) => {
  return (
    <StyledDiv marginBottom="m" marginTop="l">
      <SectionHeader>{title}</SectionHeader>
      <div data-testid="description">{description}</div>
    </StyledDiv>
  );
};

export default FormHeader;
